import React, { RefObject } from 'react';
import clsx from 'clsx';
import { Loading, Icon, Popover } from '@brighterion/br-ui';
import styles from './DashletContainer.css';

interface Header {
    label?: string;
    toolTip?: string;
}

type Props = {
    className?: string;
    header?: Header;
    subHeader?: React.ReactNode;
    isLoading?: boolean;
    children: React.ReactNode;
    dataTestId: string;
    descriptionAboveChildren?: string;
};

const DashletContainer = React.forwardRef(
    (
        {
            className,
            header = { label: '', toolTip: '' },
            subHeader = '',
            isLoading = false,
            children,
            dataTestId,
            descriptionAboveChildren
        }: Props,
        ref
    ) => {
        return (
            <div
                ref={ref as RefObject<HTMLDivElement> | null}
                data-testid={dataTestId}
                className={clsx(styles.dashletContainer, className)}
            >
                <div data-testid='header' className={styles.headerRow}>
                    <div data-testid='headerLeft' className={styles.headerLeft}>
                        {header.label}
                        {header.toolTip && (
                            <Popover
                                popperClassName={styles.popper}
                                theme='light'
                                showArrow
                                content={<div>{header.toolTip}</div>}
                                isAltText
                                contentClassName={styles.dashletTooltip}
                                arrowClassName={styles.popperArrowStyle}
                            >
                                <Icon
                                    name='small-help'
                                    size='md'
                                    className={styles.dashletTooltipIcon}
                                    aria-label='help'
                                />
                            </Popover>
                        )}
                    </div>
                    {!isLoading && <div className={styles.subHeaderRow}>{subHeader}</div>}
                </div>
                {isLoading ? (
                    <div data-testid='loading-container' className={styles.loadingContainer}>
                        <Loading size='xlg' />
                    </div>
                ) : (
                    <>
                        <div className={styles.descriptionAboveChildren}>{descriptionAboveChildren}</div>
                        {children}
                    </>
                )}
            </div>
        );
    }
);

export default DashletContainer;
